import axiosClient from './axiosClient';

export default {
  // Ricerca paginata con filtri

  // Dettaglio singolo record logprocesso
  trova: (id) => axiosClient.get(`/processi/${id}`),
  aggiorna: (id,params) => axiosClient.post(`/processi/${id}`, null, { params }),
  getByFascicolo: (fascicoloId) => axiosClient.get(`/processi/byfascicolo/${fascicoloId}`),
};